<template>
    <div class="row">
        <div class="col-12">
            <v-client-table :data="data" :columns="columns" @row-click="onRowClick"></v-client-table>
        </div>
        <ErrorLogsPreviewModal
            v-if="openModal"
            :view.sync="openModal"
            :data="selectedField"
        />
    </div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import {ClientTable} from 'vue-tables-2';
import ErrorLogsPreviewModal from '@/components/errorlogs/ErrorLogsPreviewModal';
let theme;
Vue.use(ClientTable, [theme = 'bootstrap5']);

export default {
    name: 'error-logs-preview-table',
    props: {
        record: {
            type: Object,
            required: true
        }
    },
    components: {
        ClientTable,
        ErrorLogsPreviewModal
    },
    data () {
        return {
            columns: [ 'CreatedUTC', 'Browser', 'Device', 'User', 'URL' ],
            selectedField: {},
            openModal: false
        }
    },
    async mounted () {
    },
    computed: {
        data () {
            return (this.record.ErrorLogs || []).map(log => ({
                // visible columns
                CreatedUTC: new Date(log.CreatedUTC).toLocaleString(),
                Browser: log.Browser,
                Device: log.Device,
                User: log.User,
                URL: log.URL,
                // extra fields for modal
                CreatedUTCRaw: log.CreatedUTC,
                Logs: log.Logs,
                Stack: log.Stack,
                Customer: log.Customer,
                id: log.id
            }));
        }

    },
    methods: {
        onRowClick (data) {
            const row = data && (data.row || data);
            this.selectedField = row || {};
            this.openModal = true;
        }
    }
}
</script>